<template>
  <!-- The pictures of a message, full size, over everything else: arrows (or
       the arrow keys) step through them, Escape or a click outside closes. -->
  <teleport to="body">
    <div
      ref="root"
      class="sc-lightbox"
      role="dialog"
      aria-modal="true"
      :aria-label="current ? current.name || 'Picture' : 'Picture'"
      tabindex="-1"
      @click.self="$emit('close')"
      @keydown.esc.stop.prevent="$emit('close')"
      @keydown.left.prevent="step(-1)"
      @keydown.right.prevent="step(1)"
    >
      <header class="sc-lightbox__bar">
        <span class="sc-lightbox__name">{{ current ? current.name : '' }}</span>
        <span v-if="images.length > 1" class="sc-lightbox__count">{{ position + 1 }} / {{ images.length }}</span>
        <a
          v-if="current"
          class="sc-lightbox__btn"
          :href="current.url"
          target="_blank"
          rel="noopener"
          title="Open the original"
          aria-label="Open the original"
        >
          <i class="pi pi-external-link" aria-hidden="true"></i>
        </a>
        <button type="button" class="sc-lightbox__btn" title="Close" aria-label="Close" @click="$emit('close')">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </header>
      <button
        v-if="images.length > 1"
        type="button"
        class="sc-lightbox__nav sc-lightbox__nav--prev"
        aria-label="Previous picture"
        @click="step(-1)"
      >
        <i class="pi pi-chevron-left" aria-hidden="true"></i>
      </button>
      <img v-if="current" :key="current.url" class="sc-lightbox__image" :src="current.url" :alt="current.name || 'Picture'" />
      <button
        v-if="images.length > 1"
        type="button"
        class="sc-lightbox__nav sc-lightbox__nav--next"
        aria-label="Next picture"
        @click="step(1)"
      >
        <i class="pi pi-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </teleport>
</template>
<script>
export default {
  name: 'ChatLightbox',
  props: {
    images: {
      type: Array,
      required: true,
    },
    start: {
      type: Number,
      default: 0,
    },
  },
  emits: ['close'],
  data() {
    return {
      position: Math.min(Math.max(this.start, 0), Math.max(this.images.length - 1, 0)),
    };
  },
  computed: {
    current() {
      return this.images[this.position] || null;
    },
  },
  methods: {
    step(delta) {
      if (this.images.length < 2) return;
      this.position = (this.position + delta + this.images.length) % this.images.length;
    },
  },
  mounted() {
    this.returnFocus = document.activeElement;
    this.$nextTick(() => this.$refs.root?.focus());
  },
  beforeUnmount() {
    if (this.returnFocus && typeof this.returnFocus.focus === 'function') this.returnFocus.focus();
  },
};
</script>
